export default class NewUserModel {
    displayName: string = "";
    userName: string = "";
    passkey: string = "";
    tenantId: string = "";
    IsAdmin: boolean = false;

}